import {Grid2, Typography} from "@mui/material";
import * as React from "react";
import {color_grey} from "@/agentur/AgenturColors";
import {Nr1Svg, Nr2Svg, Nr3Svg, Step1Svg, Step2Svg, Step3Svg} from "@/pages/landing-page/utils/Svgs";
import {InfoCard} from "../utils/InfoCard";
import {Section4DTO} from "@/pages/landing-page/landing-page-data";
import {compactValue} from "@/lib/screen-class";
import {LANDING_HEADLINE} from "@/pages/landing-page/utils/landing-font-sizes";
import {COLORED_SECTION_PX, COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";

interface Section4Props {
    data: Section4DTO;
}

export const Section4 = ({ data }: Section4Props) => (
    <Grid2
        container
        direction="column"
        paddingTop={4}
        sx={{
            minHeight: COMPACT_SECTION_MIN_HEIGHT,
            backgroundColor: color_grey[4],
            position: "relative",
            px: COLORED_SECTION_PX,
            // Below `md` the section is as high as its cards, so the last card keeps a distance to the grey edge.
            paddingBottom: compactValue(4, 0)
        }}
    >
        <Grid2 width="100%">
            <Typography sx={{ fontSize: LANDING_HEADLINE }} fontWeight="700">
                {data.title}
            </Typography>
        </Grid2>

        <Grid2
            container
            direction="row"
            gap={compactValue(4, 12)}
            paddingTop={compactValue(4, 10)}
            justifyContent="center"
        >
            <InfoCard nr={1} label={data.stepLabel} text={data.steps[0]} Svg={Step1Svg} NrSvg={Nr1Svg} />
            <InfoCard nr={2} label={data.stepLabel} text={data.steps[1]} Svg={Step2Svg} NrSvg={Nr2Svg} />
            <InfoCard nr={3} label={data.stepLabel} text={data.steps[2]} Svg={Step3Svg} NrSvg={Nr3Svg} />
        </Grid2>
    </Grid2>
);
